import React from 'react';
import styled from 'astroturf/react';

import { PdfMiniChip } from 'js/liswp_blocks/shared/PdfMiniChip';
import { formatStat } from 'js/liswp_blocks/shared/formatStat';

const Row = styled.div`
  display: flex;
  gap: var(--spacing-xs-12, 12px);
  align-items: flex-start;
  width: 100%;
`;

const ThumbWrap = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
`;

const Thumb = styled.img`
  flex-shrink: 0;
  width: 40px;
  height: 58px;
  object-fit: cover;
  object-position: top center;
  background: var(--background-white, #ffffff);
  border: 1px solid var(--stroke-light, #dddde2);
`;

const Body = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: var(--spacing-xs-4, 4px);
  min-width: 0;
`;

const Title = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  font-family:
    var(--type-font-family-sans-serif, 'DM Sans'), Helvetica, Arial, sans-serif;
  font-size: var(--type-body-sm-size, 14px);
  line-height: var(--type-body-sm-bold-line-height, 20px);
  font-weight: var(--type-body-sm-bold-font-weight, 600);
  color: var(--text-primary, #141413);
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-xs-8, 8px);
  font-family:
    var(--type-font-family-sans-serif, 'DM Sans'), Helvetica, Arial, sans-serif;
  font-size: var(--type-body-xs-size, 12px);
  line-height: var(--type-body-xs-line-height, 16px);
  color: var(--text-secondary, #535366);
`;

export type CurrentPaperRowProps = {
  title: string;
  thumbnailUrl?: string;
  publicationYear?: number;
  viewCount?: number;
};

export const CurrentPaperRow: React.FC<CurrentPaperRowProps> = ({
  title,
  thumbnailUrl,
  publicationYear,
  viewCount,
}) => (
  <Row>
    <ThumbWrap>
      <Thumb src={thumbnailUrl} alt="" />
      <PdfMiniChip />
    </ThumbWrap>
    <Body>
      <Title>{title}</Title>
      {(publicationYear !== undefined || viewCount !== undefined) && (
        <Meta>
          {publicationYear !== undefined && <span>{publicationYear}</span>}
          {publicationYear !== undefined && viewCount !== undefined && (
            <span>|</span>
          )}
          {viewCount !== undefined && (
            <span>{formatStat(viewCount)} views</span>
          )}
        </Meta>
      )}
    </Body>
  </Row>
);

export default CurrentPaperRow;
